import React, { useState, useEffect } from 'react'
import PropTypes from 'prop-types'
import { Lock } from '@entrata/portals-common/lib/icons'
import TextLink from 'portal-modules/common/components/TextLink'
import { connect } from 'react-redux'
import { liftLockout } from '../redux/modules/user'
import { AUTH } from '../constants/urls'
import styled from '@emotion/styled'

const StyledDiv = styled('div')`
  border-top: 2px solid ${({ theme }) => theme.gray.light};
  color: ${({ theme }) => theme.error.base};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
  justify-content: space-between;
  padding-top: 24px;

  @media screen and (min-width: 768px) {
    padding-top: 32px;
  }

  @media screen and (min-width: 1024px) {
    display: block;
    padding-top: 48px;
  }
`

const StyledCountdown = styled('p')`
  align-items: center;
  display: flex;
  font-size: 48px;
  font-weight: 300;
  letter-spacing: 4px;
  line-height: 1;
  margin: 0;

  @media screen and (min-width: 1024px) {
    font-size: 58px;
  }

  svg {
    margin-right: 16px;
  }
`

const StyledP = styled('p')`
  font-size: 13px;
  font-style: italic;
  margin-top: 0;

  @media screen and (min-width: 768px) {
    font-size: 14px;
  }
`

const StyledResetDiv = styled('div')`
  font-size: 14px;
  margin-bottom: 48px;
  text-align: center;

  @media screen and (min-width: 768px) {
    margin-top: 80px;
    text-align: left;
  }
`

const StyledTextLink = styled(TextLink)`
  align-items: center;
  display: flex;
  font-size: 14px;

  svg {
    margin-right: 8px;
  }
`

const LockoutTimer = props => {
  
  let interval = null

  useEffect(() => {
    interval = setInterval(tick, 1000)

    return () => {
      clearInterval(interval)
      interval = null
    }
  }, [])

  const calculateRemaining = () => {
    const diffMins = (props.until - Date.now()) / 60000
    const seconds = Math.round(60 * (diffMins % 1))

    if (diffMins > 0) {
      return `${Math.floor(diffMins)}:${seconds < 10 ? '0' + seconds : seconds}`
    } else {
      props.liftLockout()
      return 0
    }
  }

  const [remaining, setRemaining] = useState(calculateRemaining)

  const tick = () => {
    setRemaining(calculateRemaining)
  }

  return (
    <StyledDiv>
      <div>
        <StyledP>{__('You can try logging in again in')}</StyledP>
        <StyledCountdown>
          <Lock size={32} />
          {remaining}
        </StyledCountdown>
      </div>
      <StyledResetDiv>
        <StyledTextLink to={AUTH.RESET_PASSWORD}>
          {__('Reset My Password')}
        </StyledTextLink>
      </StyledResetDiv>
    </StyledDiv>
  )
}

LockoutTimer.propTypes = {
  liftLockout: PropTypes.func.isRequired,
  until: PropTypes.number,
}

export default connect(
  ({ user }) => ({ until: user.lockoutUntil }),
  {
    liftLockout,
  },
)(LockoutTimer)
